import { render, staticRenderFns } from "./ProjectMaterialsAndPricesTable.vue?vue&type=template&id=5e4c3458&"
import script from "./ProjectMaterialsAndPricesTable.vue?vue&type=script&lang=js&"
export * from "./ProjectMaterialsAndPricesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports